var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"p-slide_menu--account_link",attrs:{"href":_vm.url}},[_c('span',[_vm._v("アカウントサービス")])])}
var staticRenderFns = []

export { render, staticRenderFns }